import React, { Component } from 'react';
import './App.css';
import {connect} from 'react-redux';
import $ from 'jquery';


class Ertekeles extends Component {
  state = {sending:false};

  send = (ertek) => {
    let {info} = this.props;

    console.log("ertekelés: "+ertek);
    this.setState({sending:true});
    setTimeout(()=>this.setState({sending:false}),2500);
    $.ajax('https://uttars.prevost.hu/ertekeles.php', {
      method: 'POST',
      data: {uttars: info? info.nev : '?',ertek}
    })
  }

  render() {
    let msg = null;
    if(this.state.sending){
      msg = <div className="koszi">Köszönjük a visszajelzést!</div>;
    }else{
      let ertek = [];
      for(let i=1;i <= 6;i++){
        ertek.push(<span key={i} className="badge badge-primary m-1 sargaHatter " onClick={()=>this.send(i)} >{i}</span>);
      }
      msg = <h1><div>Értékelj minket:</div>{ertek}</h1>;
    }
    return <div  className="ertekeles">{msg}</div>
  }
}

export default connect(
  state => ({info:state.userInfo}),
  dispatch => ({dispatch})
)(Ertekeles);



// WEBPACK FOOTER //
// ./src/Ertekeles.js